"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const lottie_web_1 = __importDefault(require("lottie-web"));
const lottie_module_scss_1 = __importDefault(require("./lottie.module.scss"));
class Lottie extends React.Component {
    constructor(props) {
        super(props);
        this.setDirection = () => {
            this.animation.setDirection(this.props.direction);
        };
        this.playSegments = () => {
            this.animation.playSegments(this.props.segments);
        };
        this.stop = () => {
            this.animation.stop();
        };
        this.setSpeed = () => {
            if (this.props.speed) {
                this.animation.setSpeed(this.props.speed);
            }
            else {
                this.animation.setSpeed(1);
            }
        };
        this.play = () => {
            this.animation.play();
        };
        this.pause = () => {
            if (this.props.isPaused && !this.animation.isPaused) {
                this.animation.pause();
            }
            else if (!this.props.isPaused && this.animation.isPaused) {
                this.animation.pause();
            }
        };
        this.getSize = (initial) => {
            let size;
            if (typeof initial === 'number') {
                size = `${initial}px`;
            }
            else {
                size = initial || '100%';
            }
            return size;
        };
        this.lottieRef = React.createRef();
        this.mounted = false;
    }
    componentDidMount() {
        if (this.mounted) {
            return null;
        }
        const { options } = this.props;
        const { loop, autoplay, animationData, rendererSettings, segments } = options;
        this.lottieOptions = {
            container: this.lottieRef,
            renderer: 'svg',
            loop: loop !== false,
            autoplay: autoplay !== false,
            segments: segments !== false,
            animationData,
            rendererSettings,
        };
        this.lottieOptions = Object.assign(Object.assign({}, this.lottieOptions), options);
        this.animation = lottie_web_1.default.loadAnimation(this.lottieOptions);
        this.mounted = true;
        this.setSpeed();
        if (!this.props.isPaused) {
            this.play();
        }
    }
    componentDidUpdate() {
        if (this.props.isStopped) {
            this.stop();
        }
        else if (this.props.segments) {
            this.playSegments();
        }
        else {
            this.play();
        }
        this.pause();
        this.setSpeed();
        this.setDirection();
    }
    render() {
        const { width, height, title } = this.props;
        const lottieStyles = Object.assign({ width: this.getSize(width), height: this.getSize(height), overflow: 'hidden', margin: '0 auto', outline: 'none' }, this.props.style);
        return ((0, jsx_runtime_1.jsx)("div", { className: lottie_module_scss_1.default.lottie, ref: (el) => {
                this.lottieRef = el;
            }, style: lottieStyles, title: title || '', role: 'button', "aria-label": 'animation' }));
    }
}
exports.default = Lottie;
